import { Box, Switch, Typography, FormControlLabel } from '@mui/material';

import { PasswordField } from 'src/pages/channel/shared';
import { ChannelStepLayout } from 'src/pages/channel/shared/channel-step-layout';

import { Iconify } from 'src/components/iconify';
import { Form, Field } from 'src/components/hook-form';

import { useEmailIMAP } from '../hooks/useEmailIMAP';

export const EmailIMAP = () => {
  const { methods, onSubmit, watchImapEnabled, btnDisableHandler, t } = useEmailIMAP();

  const renderFields = () => (
    <Box sx={{ width: '60%', alignSelf: 'end' }}>
      {watchImapEnabled && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 3.5,
          }}
        >
          <Field.Text
            name="imapAddress"
            label={t('ADDRESS')}
            InputLabelProps={{ shrink: true }}
            placeholder={t('ENTER_IMAP_ADDRESS')}
          />

          <Field.Number
            name="imapPort"
            label={t('PORT')}
            type="number"
            InputLabelProps={{ shrink: true }}
            placeholder={t('ENTER_IMAP_PORT')}
          />

          <Field.Text
            name="imapLogin"
            label={t('USERNAME')}
            InputLabelProps={{ shrink: true }}
            placeholder={t('ENTER_IMAP_LOGIN')}
          />

          <PasswordField name="imapPassword" label={t('PASSWORD')} />

          <FormControlLabel
            control={
              <Switch
                {...methods.register('imapEnableSsl')}
                checked={methods.watch('imapEnableSsl')}
                onChange={(e) => methods.setValue('imapEnableSsl', e.target.checked)}
              />
            }
            label={<Typography variant="subtitle1">{t('ENABLE_SSL_FOR_IMAP')}</Typography>}
          />

          {!watchImapEnabled && (
            <Box
              sx={{
                textAlign: 'center',
                py: 6,
                color: 'text.secondary',
              }}
            >
              <Iconify icon="solar:letter-bold" width={48} sx={{ mb: 2, opacity: 0.5 }} />
              <Typography variant="body2">{t('IMAP_DISABLED_MESSAGE')}</Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );

  const enableProviderConfigTitle = t('ENABLE_PROVIDER_CONFIGURATION').replace(
    '{PROVIDER_NAME}',
    t('IMAP')
  );

  const sendProviderDetailsTitle = t('SEND_PROVIDER_DETAILS').replace('{PROVIDER_NAME}', t('IMAP'));

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <ChannelStepLayout title="" isNextDisabled={btnDisableHandler()}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.8,
                ml: 8,
              }}
            >
              <Typography variant="subtitle1">{t('IMAP')}</Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {sendProviderDetailsTitle}
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.8,
                width: '60%',
              }}
            >
              <FormControlLabel
                control={
                  <Switch
                    {...methods.register('imapEnabled')}
                    checked={watchImapEnabled}
                    onChange={(e) => methods.setValue('imapEnabled', e.target.checked)}
                  />
                }
                label={<Typography variant="subtitle1">{enableProviderConfigTitle}</Typography>}
              />

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {t('ENABLE_IMAP_DESCRIPTION')}
              </Typography>
            </Box>
          </Box>

          {renderFields()}
        </Box>
      </ChannelStepLayout>
    </Form>
  );
};
